import React, { createContext, useMemo } from 'react';

import { createUniqueKey } from '../iframe/channel';

export type UniqueKeyContext = {
	uniqueKey: string | undefined;
};

export const UniqueKeyContext: React.Context<UniqueKeyContext> = createContext<UniqueKeyContext>({
	uniqueKey: undefined,
});

// When there are multiple embedded confluence instances on the same page,
// we need to use a unique key to identify each instance to avoid communication conflicts.
export const UniqueKeyProvider = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	const uniqueKey = useMemo(() => createUniqueKey(), []);
	return <UniqueKeyContext.Provider value={{ uniqueKey }}>{children}</UniqueKeyContext.Provider>;
};
